import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from 'src/app/_user/pages/login/login.component';
import { LoginInformationsComponent } from 'src/app/_user/pages/login-informations/login-informations.component';
import { AuthGuard } from 'src/app/_user/guards/auth.guard';

const routes: Routes = [
    {
        path: 'user',
        children: [
            {path: '', redirectTo: 'login', pathMatch: 'full'},
            {path: 'login', component: LoginComponent},
            {path: 'informations', component: LoginInformationsComponent},
        ]
    },
    {
        path: 'user',
        outlet: 'content',
        children: [
            {path: '', redirectTo: 'login', pathMatch: 'full'},
            {path: 'login', component: LoginComponent},
            {path: 'informations', component: LoginInformationsComponent},
        ]
    },
    {
        path: 'user',
        outlet: 'focus',
        children: [
            {path: '', redirectTo: 'login', pathMatch: 'full'},
            {path: 'login', component: LoginComponent},
            {path: 'informations', component: LoginInformationsComponent},
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UserRoutingModule {
}
